import { Link } from "react-router-dom";

export default function Error() {
  return (
    <div className="h-full">
      <h1>Halaman tidak ditemukan!</h1>
      <p>
        Kembali ke halaman{" "}
        <Link to="/" className="text-blue-600 hover:underline">
          Beranda
        </Link>
        .
      </p>
    </div>
  );
}
